import React, { useEffect } from 'react';
import { Icon, Button } from '@blueprintjs/core';

export function LockElement(editor) {
  const { Canvaseditor, setdisabledObj, setLockObj, LockObj } = editor;
  useEffect(() => {
    // On object select.
    if (Canvaseditor.contextContainer) {
      Canvaseditor.on('selection:created', function () {
        setLockObj('unlock');
      });
    }
  });

  // Set Lock Object.
  const handleLockObj = () => {
    if (LockObj === 'unlock') {
      setLockObj('lock');
      var activeObject = Canvaseditor.getActiveObject();
      if (activeObject) {
        activeObject.selectable = false;
        activeObject.evented = false;
        activeObject.hoverCursor = 'default';
        Canvaseditor.discardActiveObject().renderAll();
        if (typeof Canvaseditor.fire === "function") Canvaseditor.fire("canvas:state-changed");
      }
    } else {
      setdisabledObj(false);
      setLockObj('unlock');
      var items = Canvaseditor.getObjects();

      if (!items) {
        return;
      }

      items.forEach(function (item) {
        if (item.selectable === false) {
          item.selectable = true;
          item.hoverCursor = 'move';
          item.evented = true;
        }
      });
      Canvaseditor.discardActiveObject().renderAll();
      if (typeof Canvaseditor.fire === "function") Canvaseditor.fire("canvas:state-changed");
    }
  };
  return (
    <div className="lockObj">
      <Button onClick={handleLockObj} icon={<Icon icon={LockObj} />} />
    </div>
  );
}
